export default {"src":"/_next/static/media/ic_notification_bell.a53868e8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};